import either, { right } from "../../../lib/either";
import DepParentsRemoteDataSource from "../datasources/dep_parents_remote_datasource";

const SaveInvoiceDataUseCase = (data) =>
  either(async () => {
    const response = await DepParentsRemoteDataSource.saveInvoiceInfo(data);
    return right(response);
  });

export default SaveInvoiceDataUseCase;
